import React from 'react'

function SecurityBanner () {
    const handleClick = (url) => {
        window.open(url, '_blank')
    }

    return (
        <div className="security_bnr">
            <dl className="nortonSecuredDetail">
            <dt><script type="text/javascript" src="https://seal.verisign.com/getseal?host_name=www.metlife.co.jp&amp;size=S&amp;use_flash=NO&amp;use_transparent=YES&amp;lang=ja"></script></dt>
            <dd>当サイトはお客様の個人情報を安全に送受信するために<br className="pcOnly"/>128bit版SSL（暗号化通信）を使用しております。<br/><a href="#" onClick={() => handleClick('http://www.metlife.co.jp/about/governance/ev-ssl/#h2Area03')}>詳細はこちらをご覧ください。</a></dd>
            </dl>
        </div>
    )
}

export default SecurityBanner
